module.exports = __webpack_public_path__ + "static/media/19.2992b718.mp3";